import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=47ebef3a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ebef3a')) {
      api.createRecord('47ebef3a', component.options)
    } else {
      api.reload('47ebef3a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=47ebef3a&", function () {
      api.rerender('47ebef3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-254t7JTFSmZrw/JS/imageCarousel.vue"
export default component.exports